import React, { forwardRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart, LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import {
    GridComponent,
    LegendComponent,
    DatasetComponent,
    TooltipComponent,
    ToolboxComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import * as echarts from 'echarts/core';
import PropTypes from 'prop-types';


echarts.use([
    DatasetComponent,
    TooltipComponent,
    ToolboxComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    LineChart,
    CanvasRenderer,
    UniversalTransition
]);


const ItemsPorVendedor = forwardRef(({ ventasPorVendedor, vendedores }, ref) => {

    // Verificar que los datos existan antes de procesarlos
    if (!ventasPorVendedor || !vendedores || vendedores.length === 0) {
        return <div>Cargando gráfico...</div>;
    }

    // Generar series dinámicamente basado en el número real de vendedores
    var seriesType = [];
    vendedores.forEach(() => {
        var type = {};
        type.type = "bar";
        seriesType.push(type);
    });

    console.log("Número de vendedores:", vendedores.length);
    console.log("Series generadas:", seriesType);

    const option = {
        legend: {},
        tooltip: {},
        toolbox: {
            feature: {
                magicType: { show: true, type: ['line', 'bar'] },
                saveAsImage: { show: true }
            }
        },  
        dataset: {
            dimension: vendedores,
            source: ventasPorVendedor
        },
        xAxis: { type: 'category'},
        yAxis: {},
        series: seriesType, // Usar el array generado dinámicamente
        itemStyle: {
            borderRadius: [3, 3, 0, 0]
        },
        barWidth: '10px',
        grid: {
            top: '20%',
            bottom: 0,
            left: 0,
            right: 0,
            containLabel: true
        }
    }

  return (
    <ReactEChartsCore
        echarts={echarts}
        option={option}
        ref={ref}
    />
  );
});

ItemsPorVendedor.propTypes = {
    ventasPorVendedor: PropTypes.any,
    vendedores: PropTypes.any,
};

export default ItemsPorVendedor;
